import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "84",
  height: "84",
  viewBox: "0 0 84 84",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M55.5553 17.9258C51.7035 17.9258 47.8516 19.4073 45.185 22.2221L42.0739 25.4813L38.8146 22.2221C33.185 16.5924 23.8516 16.4443 18.222 22.2221C12.4442 27.9999 12.4442 37.185 18.222 42.9628L23.259 47.8517L40.2961 64.8887C40.7405 65.3332 41.4813 65.6295 42.0739 65.6295C42.8146 65.6295 43.4072 65.3332 43.8516 64.8887L60.8887 47.8517L65.7776 42.9628C71.4072 37.185 71.4072 27.9999 65.7776 22.2221C63.1109 19.5554 59.259 17.9258 55.5553 17.9258Z",
      fill: "#E10019"
    }, null, -1)
  ])))
}
export default { render: render }